import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=4c4a0be6&"
import script from "./NotFoundView.vue?vue&type=script&lang=ts&"
export * from "./NotFoundView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4a0be6')) {
      api.createRecord('4c4a0be6', component.options)
    } else {
      api.reload('4c4a0be6', component.options)
    }
    module.hot.accept("./NotFoundView.vue?vue&type=template&id=4c4a0be6&", function () {
      api.rerender('4c4a0be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/NotFoundView.vue"
export default component.exports